import { Component, OnInit } from '@angular/core';
import { DialogService } from '@cyborg-monorepo/common/angular/cyborg-ui';
import {
  ApiKey,
  API_KEYS_MAX_KEYS,
  CreatedApiKey,
} from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { UserService } from '../../../shared/services/user.service';
import { APIKeyDialogComponent } from './api-key-dialog/api-key-dialog.component';

@Component({ standalone: false, 
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.scss'],
})
export class ApiKeysComponent implements OnInit {
  public readonly apiDocUrl = `${environment.api}/docs/`;
  public readonly keyLimit: number = API_KEYS_MAX_KEYS;

  public apiKeys$: Observable<{ keys: Array<ApiKey> }>;

  constructor(
    private userService: UserService,
    private dialogService: DialogService,
  ) {}

  public ngOnInit(): void {
    this.getKeys();
  }

  public getKeys(): void {
    this.apiKeys$ = this.userService.getApiKeys();
  }

  public onCreateKey(name: string): void {
    this.userService.createApiKey(name).subscribe((apiKey: CreatedApiKey) => {
      this.getKeys();

      this.dialogService.open(APIKeyDialogComponent, {
        data: { apiKey: apiKey.key, keyName: apiKey.name },
      });
    });
  }

  public onRemoveKey(keyId: string): void {
    this.userService.deleteApiKey(keyId).subscribe(() => this.getKeys());
  }
}
